import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkBreak = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 256,
	height: 256,
	fill: "currentColor",
	viewBox: "0 0 256 256",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 256,
			height: 256,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 96,
			y1: 72,
			x2: 96,
			y2: 48,
			fill: "none",
			stroke: "#000000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 160,
			y1: 208,
			x2: 160,
			y2: 184,
			fill: "none",
			stroke: "#000000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72,
			y1: 96,
			x2: 48,
			y2: 96,
			fill: "none",
			stroke: "#000000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 208,
			y1: 160,
			x2: 184,
			y2: 160,
			fill: "none",
			stroke: "#000000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
			fill: "none",
			stroke: "#000000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
			fill: "none",
			stroke: "#000000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 16
		})
	]
});
export default SvgLinkBreak;
